/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { AssociatedCompanyListItemViewModel } from "../types/AssociatedCompanyListItemViewModel.ts";
import { eAssociatedCompanyStatusSchema } from "./eAssociatedCompanyStatusSchema.ts";

export const associatedCompanyListItemViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  code: z.string().nullish(),
  name: z.string().nullish(),
  contact: z.string().nullish(),
  email: z.string().nullish(),
  phone: z.string().nullish(),
  cnpj: z.string().nullish(),
  peopleCount: z.optional(z.number().int()),
  poloId: z.number().int().nullish(),
  poloName: z.string().nullish(),
  status: z.optional(
    z
      .lazy(() => eAssociatedCompanyStatusSchema)
      .describe("1 = Associated | 2 = InProcess | 3 = NotAssociated | "),
  ),
  active: z.optional(z.boolean()),
}) as unknown as ToZod<AssociatedCompanyListItemViewModel>;
